/**
 * The only thing this computer remembers about signing in.
 *
 * NOT the session. Nobody is kept signed in across a refresh, a closed tab or
 * a restart — managers, cashiers and accountants all type their username and
 * password again, and a waiter taps their tile and their PIN again. No token
 * is ever written to disk, so a till left unattended is a till nobody is
 * signed in to.
 *
 * What IS remembered is which business this till serves. The waiter tiles have
 * to be filtered by business, but the login screen runs before anyone has
 * signed in — so the till records the business of the last person who
 * successfully authenticated on it and shows that set of tiles. A till serves
 * one restaurant; when it doesn't, the first sign-in from the other one swaps
 * the tiles over.
 *
 * Reads and writes are wrapped: localStorage throws in a few situations
 * (disabled storage, a full quota) and that must never be why the app won't
 * start.
 */

const TILL_BUSINESS_KEY = 'dalabtire.tillBusiness.v1';

export function readTillBusinessId() {
  try {
    return window.localStorage.getItem(TILL_BUSINESS_KEY) || '';
  } catch (err) {
    return '';
  }
}

export function writeTillBusinessId(businessId) {
  if (!businessId) return;
  try {
    window.localStorage.setItem(TILL_BUSINESS_KEY, String(businessId));
  } catch (err) {
    /* storage unavailable — the rail just comes up empty */
  }
}
